import React from 'react';

const NoAccess = () =>
  <div>
    <h1>No tienes permisos para ver este contenido.</h1>
  </div>

export default NoAccess;
